export default __webpack_public_path__ + "static/media/logo.549d102f.svg";